<app-page-title
  [heading]="heading"
  [subheading]="subheading"
  [icon]="icon">
</app-page-title>

<div class="ttd__table-wrap">
  <div class="wrapper col-12 col-md-12">
    <div class="table-card">
      <div class="table-toolbar">
        <div class="row g-0 align-items-stretch">
          <div class="col-12 col-md-11">
            <mat-form-field
              appearance="outline"
              floatLabel="never"
              class="w-100 toolbar-field no-notch"
              color="primary">
              <mat-icon matPrefix>search</mat-icon>
              <mat-label>Search</mat-label>
              <input matInput [(ngModel)]="search" placeholder="Id, Name, FPD Secret..." (input)="applyFilter()">
              <button mat-icon-button matSuffix aria-label="Clear" (click)="search=''; applyFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4 d-flex justify-content-md-end">
            <button
              type="button"
              mat-stroked-button
              color="primary"
              class="toolbar-btn btn-eq-height add-btn"
              (click)="createPartner()"
              aria-label="Crear cuenta">
              <mat-icon>add</mat-icon>
              New Partner
            </button>

            <button
              type="button"
              mat-flat-button
              color="primary"
              class="toolbar-btn save-btn"
              (click)="savePartners()"
              *ngIf="isDirty && !loading"
              [disabled]="loading || !isDirty"
              aria-label="Guardar cambios">
              <mat-icon *ngIf="!loading">save</mat-icon>
              <span *ngIf="!loading">Save</span>
              <mat-progress-spinner
                *ngIf="loading"
                diameter="18"
                strokeWidth="3"
                mode="indeterminate">
              </mat-progress-spinner>
              <span class="dirty-dot" aria-hidden="true"></span>
            </button>
          </div>
        </div>
        <div class="unsaved-hint" *ngIf="isDirty && !loading">
          <mat-icon>info</mat-icon>
          You have unsaved changes. Click “Save” to save your changes.
        </div>
      </div>

      <div class="ttd-table">
        <div class="grid header sticky">
          <div class="th" (click)="toggleSort('id')">
            <span class="label">ID</span>
            <mat-icon class="sort" *ngIf="isSorted('id','asc')">arrow_upward</mat-icon>
            <mat-icon class="sort" *ngIf="isSorted('id','desc')">arrow_downward</mat-icon>
          </div>

          <div class="th" (click)="toggleSort('name')">
            <span class="label">NAME</span>
            <mat-icon class="sort" *ngIf="isSorted('name','asc')">arrow_upward</mat-icon>
            <mat-icon class="sort" *ngIf="isSorted('name','desc')">arrow_downward</mat-icon>
          </div>

          <div class="th" (click)="toggleSort('secret')">
            <span class="label">FPD SECRET</span>
            <mat-icon class="sort" *ngIf="isSorted('secret','asc')">arrow_upward</mat-icon>
            <mat-icon class="sort" *ngIf="isSorted('secret','desc')">arrow_downward</mat-icon>
          </div>

          <div class="th ta-right" (click)="toggleSort('advertisers')">
            <span class="label">ADVERTISERS</span>
            <mat-icon class="sort" *ngIf="isSorted('advertisers','asc')">arrow_upward</mat-icon>
            <mat-icon class="sort" *ngIf="isSorted('advertisers','desc')">arrow_downward</mat-icon>
          </div>

          <div class="th ta-right">
            <span class="label"></span>
          </div>
        </div>

        <div class="rows">
          <ng-container *ngFor="let row of pageSlice">
            <div class="grid data-row row-clickable"
                 [class.expanded]="expanded.has(row.id)"
                 (click)="toggleRow(row)">

              <div class="td id">
                <span class="mono id-pill"
                      [matTooltip]="row.id"
                      [innerHTML]="highlight(row.id, search)">
                </span>
              </div>

              <div class="td name">
                <span class="text-truncate"
                      [matTooltip]="row.name"
                      [innerHTML]="highlight(row.name, search)">
                </span>
              </div>

              <div class="td secret">
                <div class="secret-cell" *ngIf="row.firstPartyDataSecretKey && row.firstPartyDataSecretKey.trim().length">
                  <span class="fpd-chip"
                        [matTooltip]="row.firstPartyDataSecretKey"
                        [innerHTML]="highlight(row.firstPartyDataSecretKey, search)"></span>
                </div>
              </div>

              <div class="td adv ta-right cell-adv">
                <button type="button"
                        class="adv-notif"
                        (click)="$event.stopPropagation(); toggleRow(row)"
                        [attr.aria-expanded]="expanded.has(row.id)"
                        [class.is-expanded]="expanded.has(row.id)"
                        matTooltip="{{ advertisersCount(row) }} advertiser{{ advertisersCount(row)===1 ? '' : 's' }} · click to {{ expanded.has(row.id) ? 'collapse' : 'expand' }}">
                  <mat-icon class="adv-notif__icon" aria-hidden="true">campaign</mat-icon>
                  <span class="adv-notif__badge" [class.is-empty]="advertisersCount(row) === 0">
                    {{ advertisersCount(row) }}
                  </span>
                </button>
              </div>

              <div class="td actions ta-right">
                <div class="actions-cell" (click)="$event.stopPropagation()">
                  <button type="button" mat-icon-button class="action-btn"
                          matTooltip="Editar" aria-label="Editar fila"
                          (click)="editPartner(row)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button type="button" mat-icon-button class="action-btn action-btn--warn"
                          matTooltip="Eliminar" aria-label="Eliminar fila"
                          (click)="deletePartner(row)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>

            <div class="detail-row" *ngIf="expanded.has(row.id)">
              <mat-accordion displayMode="flat" class="detail-accordion">
                <mat-expansion-panel class="detail-panel"
                                    [expanded]="true"
                                    (closed)="expanded.delete(row.id)">
                  <mat-expansion-panel-header class="detail-header d-none"></mat-expansion-panel-header>
                  <div class="detail">
                    <h4>Advertisers</h4>

                    <ng-container *ngIf="row.advertisers?.length; else noAdv">
                      <div class="adv-grid">
                        <div class="adv-card" *ngFor="let a of row.advertisers">
                          <div class="adv-card__top">
                            <div
                              class="title"
                              [innerHTML]="highlight(a.name, search)"
                              [matTooltip]="a.name"
                              matTooltipPosition="above"
                              [matTooltipDisabled]="!(a?.name && a.name.length > 22)"
                              [attr.title]="a?.name || null">
                            </div>

                            <div class="adv-actions">
                              <button
                                type="button"
                                class="adv-action-btn"
                                matTooltip="Editar advertiser"
                                aria-label="Editar advertiser"
                                (click)="$event.stopPropagation(); editAdvertiser(row, a)">
                                <mat-icon>edit</mat-icon>
                              </button>

                              <button
                                type="button"
                                class="adv-action-btn adv-action-btn--warn"
                                matTooltip="Eliminar advertiser"
                                aria-label="Eliminar advertiser"
                                (click)="$event.stopPropagation(); deleteAdvertiser(row, a)">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          </div>

                          <div class="sub">
                            <code
                              class="mono id-pill"
                              [innerHTML]="highlight(a.id, search)"
                              [matTooltip]="a.id"
                              matTooltipPosition="above"
                              [matTooltipDisabled]="!(a?.id && a.id.length > 12)"
                              [attr.title]="a?.id || null">
                            </code>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    
                    <ng-template #noAdv>
                      <em class="muted">There are no advertisers</em>
                    </ng-template>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="table-footer">
      <div class="paginator-grid">
        <div class="p-left">
          Page <strong>{{ pageIndex + 1 }}</strong> of <strong>{{ totalPages }}</strong>
          <span class="muted">· {{ sorted.length }} items</span>
        </div>

        <div class="p-center">
          <button type="button" class="nav-btn" [disabled]="pageIndex===0" (click)="goToPage(0)" aria-label="Primera">
            <mat-icon>first_page</mat-icon>
          </button>
          <button type="button" class="nav-btn" [disabled]="pageIndex===0" (click)="prevPage()" aria-label="Anterior">
            <mat-icon>chevron_left</mat-icon>
          </button>

          <ng-container *ngFor="let p of pageWindow">
            <button *ngIf="p !== '…'" type="button"
                    class="page-btn" [class.active]="p-1 === pageIndex"
                    (click)="goToPage(p-1)">{{ p }}</button>
            <span *ngIf="p === '…'" class="ellipsis">…</span>
          </ng-container>

          <button type="button" class="nav-btn" [disabled]="pageIndex>=totalPages-1" (click)="nextPage()" aria-label="Siguiente">
            <mat-icon>chevron_right</mat-icon>
          </button>
          <button type="button" class="nav-btn" [disabled]="pageIndex>=totalPages-1" (click)="goToPage(totalPages-1)" aria-label="Última">
            <mat-icon>last_page</mat-icon>
          </button>
        </div>

        <div class="p-right">
          <div class="page-size-inline">
            <span class="page-size-label">Items per page:</span>

            <mat-form-field
              appearance="outline"
              floatLabel="never"
              class="page-size-field no-notch"
              color="primary"
              aria-label="Items per page">
              <mat-select [value]="pageSize" (selectionChange)="changePageSize($event.value)">
                <mat-option *ngFor="let sz of pageSizeOptions" [value]="sz">{{ sz }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
